import dayjs from "dayjs";

export const dateToCorrectFormat = (date) => {
  return dayjs(date).format("YYYY-MM-DD");
};
